// extracted by mini-css-extract-plugin
export default {"quote-name":"quotes_quote-name__nLkL6","approval-type":"quotes_approval-type__Nmmpc","quote-status":"quotes_quote-status__uYoG7","quote-id":"quotes_quote-id__goJel"};